import { Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material'
import { t } from 'i18next'


const GatewayStatus = ({ filters, onChange }) => {
  const status = filters?.status || []

  const handleChange = ({ target: { name } }) => {
    const newStatus = status.includes(name)
      ? status.filter((s) => s !== name)
      : status.concat(name)
    onChange({ status: newStatus })
  }

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        spacing={2}
        mt={3}
        mb={3}
      >
        <Typography
          id="gateway-status-label"
          align="left"
          sx={{ fontWeight: 'bold' }}
        >
          {t('filters.gateways.status.label')}
        </Typography>
        <FormGroup
          row
        >
          <FormControlLabel
            id="gateway-status-attivo-label"
            value="Attivo"
            control={
              <Checkbox
                name="Attivo"
                onChange={handleChange}
                aria-labelledby="gateway-status-label"
                checked={status.includes('Attivo')}
              />
            }
            label={t('filters.gateways.status.active')}
          />
          <FormControlLabel
            id="gateway-status-guasto-label"
            value="Guasto"
            control={
              <Checkbox
                name="Guasto"
                onChange={handleChange}
                aria-labelledby="gateway-status-label"
                checked={status.includes('Guasto')}
              />
            }
            label={t('filters.gateways.status.failure')}
          />
          <FormControlLabel
            id="gateway-status-disattivo-label"
            value="Disattivo"
            control={
              <Checkbox
                name="Disattivo"
                onChange={handleChange}
                aria-labelledby="gateway-status-label"
                checked={status.includes('Disattivo')}
              />
            }
            label={t('filters.gateways.status.deactivated')}
          />
          <FormControlLabel
            id="gateway-status-in-lavorazione-label"
            value="In lavorazione"
            control={
              <Checkbox
                name="In lavorazione"
                onChange={handleChange}
                aria-labelledby="gateway-status-label"
                checked={status.includes('In lavorazione')}
              />
            }
            label={t('filters.gateways.status.inProgress')}
          />
          <FormControlLabel
            id="gateway-status-in-magazzino-label"
            value="In magazzino"
            control={
              <Checkbox
                name="In magazzino"
                onChange={handleChange}
                aria-labelledby="gateway-status-label"
                checked={status.includes('In magazzino')}
              />
            }
            label={t('filters.gateways.status.inStock')}
          />
        </FormGroup>
      </Stack>
    </>
  )
}

export default GatewayStatus
